import "../../containers/SpAndSuAnalysis/style.css";
import { FiTrendingUp, FiTrendingDown } from "react-icons/fi";

export const MetricCard = ({ title, value, icon: Icon, variant = "primary", isFooter = false, previousCount = 0, incrementPercentage = 0 }) => {
    return (
        <div className={`metric-card ${variant}`}>
            <div className="metric-header">
                <div className="metric-content">
                    <div className="metric-label">{title}</div>
                    <div className="metric-value">{value}</div>
                </div>
                <div className={`metric-icon ${variant}`}>
                    <Icon size={22} />
                </div>
            </div>
            {
                isFooter &&
                <div style={{ marginTop: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span className="metric-label" style={{ paddingBottom: 0, marginBottom: 0, fontSize: '12px' }}>vs previous: {previousCount}</span>
                    <span className="metric-label" style={{ paddingBottom: 0, marginBottom: 0, color: incrementPercentage < 0 ? '#dd1727ff' : '#0DAF7A', display: 'flex', gap: '3px', fontSize: '12px', alignItems: 'center' }}>
                        {incrementPercentage < 0 ? <FiTrendingDown /> : <FiTrendingUp />}
                        {incrementPercentage?.toFixed(2)}%
                    </span>
                </div>
            }
        </div>
    );
};
